import { z } from 'zod';
import { localeSchema, objectIdSchema } from './common.js';
export const createOrgSchema = z.object({
    name: z.string().min(1).max(200),
    /** IANA timezone. CLAUDE.md: всё в UTC, отображение в зоне юнита или пользователя. */
    timezone: z.string().min(1).max(64).default('America/Chicago'),
    defaultLocale: localeSchema.default('en'),
});
/**
 * Площадка (терминал/двор). CLAUDE.md: в MVP может быть одна на организацию
 * и не показываться в интерфейсе, но в модели обязана быть с первого дня —
 * от неё зависят маршрутизация уведомлений и область действия ролей.
 */
export const createSiteSchema = z.object({
    name: z.string().min(1).max(200),
    code: z.string().min(1).max(32).regex(/^[A-Z0-9_-]+$/i),
    timezone: z.string().min(1).max(64).optional(),
    /** Геозона двора — используется как сигнал Trust Score на фазе 3. */
    geofence: z
        .object({
        lat: z.number().min(-90).max(90),
        lon: z.number().min(-180).max(180),
        radiusMeters: z.number().int().min(50).max(20000),
    })
        .optional(),
});
export const updateSiteSchema = createSiteSchema.partial();
export const siteSchema = createSiteSchema.extend({
    id: objectIdSchema,
    orgId: objectIdSchema,
    createdAt: z.coerce.date(),
});
//# sourceMappingURL=org.js.map